import { useState } from 'react';

import { Button } from '@/components/ui/button';
import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger
} from '@/components/ui/drawer';
import LoginForm from './components/loginDrawer/LoginForm';

const LoginDrawer = ({ onSuccess }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleSuccess = async () => {
    setIsOpen(false);
    if (onSuccess) {
      await onSuccess();
    }
  };

  return (
    <Drawer open={isOpen} onOpenChange={(value) => setIsOpen(value)}>
      <DrawerTrigger asChild>
        <Button size="sm">Log In</Button>
      </DrawerTrigger>
      <DrawerContent>
        <DrawerHeader>
          <DrawerTitle className="text-3xl">Login</DrawerTitle>
          <DrawerDescription>ProFound</DrawerDescription>
          <LoginForm onSuccess={handleSuccess} />
        </DrawerHeader>
      </DrawerContent>
    </Drawer>
  );
};

export default LoginDrawer;
